import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink } from "@angular/router";
import { MeddelandeInfotavlaDTO } from "~app/common/models/meddelandeInfotavla/MeddelandeInfotavlaDTO";
import { SystemaktivitetNotisTexts } from "~app/features/administration/systemaktivitet/systemaktivitet-notis/systemaktivitet-notis.texts";
import { SystemaktivitetService } from "~app/features/administration/systemaktivitet/systemaktivitet.service";

@Component({
    selector: "rask-systemaktivitet-notis",
    templateUrl: "./systemaktivitet-notis.component.html",
    styleUrls: ["./systemaktivitet-notis.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink]
})
export class SystemaktivitetNotisComponent {
    systemaktivitetlista: MeddelandeInfotavlaDTO[];
    texts = SystemaktivitetNotisTexts.texts;

    private readonly systemaktivitetService = inject(SystemaktivitetService);

    constructor() {
        this.systemaktivitetService.currentMeddelandeInfotavlor$.subscribe(x => this.onActiveMeddelandetavlorChanged(x));
    }

    dismiss(systemaktivitet) {
        this.systemaktivitetService.dismissMeddelandeInfotavla(systemaktivitet);
    }

    onActiveMeddelandetavlorChanged(result: MeddelandeInfotavlaDTO[]) {
        this.systemaktivitetlista = result;
    }
}
